import _, { update } from 'lodash'
import order from '@/service/order'
import { OrderDetails, Order, IOrderProductsMap } from '@/service/types'
import { IParamUpdateQuantity, IParamUpdateValidationProduct, IQueueElement } from '../types';
import { orderAutorefreshIntervalNumber } from '@/config';

export default {
  async fetch(store: any, payload: any) {
    const resp: Array<Order> = await order.getAll();
    if (resp instanceof Array && _.first(resp) instanceof Order) {
      store.commit('UPDATE_ORDERS', resp);
    }
    return resp;
  },
  async fetchMap(store: any, payload: any) {
    const resp: IOrderProductsMap = await order.getMap();
    store.commit('UPDATE_MAP', resp);
    return resp;
  },
  async fetchOne(store: any, idOrder: number) {
    const resp: OrderDetails = await order.getOne(idOrder)
    if (resp instanceof OrderDetails) {
      store.commit('UPDATE_DETAILED', resp);
    }
    return resp;
  },
  async updateOrders(store: any, force: boolean = false) {
    if (!force && store.getters.nextPossibleUpdateTime > (new Date()).getTime()) {
      return;
    }
    store.commit(
      'UPDATE_NEXT_POSSIBLE_UPDATE_TIME', 
      (new Date()).getTime() + orderAutorefreshIntervalNumber - 3000
    );
    await store.dispatch('fetch');
    await store.dispatch('fetchMap');
    const productsToFetch: Array<any> = store.getters.getIdsFromMap;
    if (productsToFetch.length) {
      await store.dispatch(
        'product/fetchSelectedProducts', 
        {
          where: {
            id: productsToFetch,
          }
        }, 
        {root:true}
      );
    }
  },
  // async reject(store: any, idOrder: number) {
  //   return order.reject(idOrder);
  // },
  async reject(store: any, idOrder: number) {
    return new Promise((resolve) => {
      const req: IQueueElement = {
        actionType: 'reject',
        idOrder
      };
      store.commit('ENQUEUE_REQUEST', req);
      resolve(true);
    });
  },
  // async confirm(store: any, idOrder: number) {
  //   return order.confirm(idOrder);
  // },
  async confirm(store: any, idOrder: number) {
    return new Promise((resolve) => {
      const req: IQueueElement = {
        actionType: 'confirm',
        idOrder
      };
      store.commit('ENQUEUE_REQUEST', req);
      resolve(true);
    });
  },
  cancel(store: any, idOrder: number) {
    store.commit('REMOVE_VALIDATION_CONTEXT', idOrder);
  },
  updateSearchQuery(store: any, payload: string) {
    store.commit('UPDATE_SEARCH_QUERY', payload);
  },
  updateQty(store: any, payload: IParamUpdateQuantity) {
    store.commit('UPDATE_VALIDATION', payload);
  },
  updateValidationProduct(store: any, payload: IParamUpdateValidationProduct) {
    store.commit('UPDATE_VALIDATION_PRODUCT', payload);
  },
};
